import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

import { JobApplication } from '../../types';
import JobListItem from './JobListItem';
import LoadMoreButton from './LoadMoreButton';

interface ExternalJobsSubListProps {
    jobs: JobApplication[];
    canLoadMore: boolean;
    onLoadMore: () => void;
    isLoading: boolean;
}

export default function ExternalJobsSubList({
    jobs,
    canLoadMore,
    onLoadMore,
    isLoading
}: ExternalJobsSubListProps) {
    return (
        <Stack component="section">
            <JobsStack>
                { jobs.map((job) => (
                    <JobListItem key={ job.id }
                        job={ job } />
                )) }
            </JobsStack>

            { canLoadMore && (
                <LoadMoreButton
                    onClick={ onLoadMore }
                    loading={ isLoading }
                />
            ) }
        </Stack>
    );
}

const JobsStack = styled(Stack)(({ theme }) => ({
    rowGap: theme.spacing(3)
}));
